import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";

export function StaffPasswordGate() {
    const { refresh } = useAuth();
    const [f, setF] = useState({ current: "", next: "", confirm: "" });
    const [busy, setBusy] = useState(false);
    const submit = async () => {
        if (f.next.length < 8) return toast.error("New password must be at least 8 characters");
        if (f.next !== f.confirm) return toast.error("Passwords don't match");
        if (f.next === f.current) return toast.error("Choose a password different from the temporary one");
        setBusy(true);
        try { await api.post("/auth/change-password", { current_password: f.current, new_password: f.next }); toast.success("Password changed — welcome to HOMIIE"); await refresh(); }
        catch (err) { toast.error(apiError(err.response?.data?.detail)); }
        finally { setBusy(false); }
    };
    const cls = "w-full rounded-xl border border-navy/15 px-4 py-3 text-sm outline-none focus:border-orange";
    return (
        <div data-testid="staff-password-gate" className="mx-auto mt-10 max-w-sm rounded-2xl border border-navy/10 bg-white p-6">
            <h1 className="flex items-center gap-2 font-heading text-xl font-extrabold text-navy"><KeyRound className="text-orange" /> Set your password</h1>
            <p className="mt-1 text-sm text-navy/55">You signed in with a temporary password. Set your own to continue.</p>
            <div className="mt-4 space-y-2.5">
                <input data-testid="staff-current-password" type="password" aria-label="Temporary password" placeholder="Temporary password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} className={cls} />
                <input data-testid="staff-new-password" type="password" aria-label="New password" placeholder="New password (min 8 characters)" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} className={cls} />
                <input data-testid="staff-confirm-password" type="password" aria-label="Confirm new password" placeholder="Confirm new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className={cls} />
            </div>
            <button data-testid="staff-password-save" disabled={busy} onClick={submit} className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-navy py-3 text-sm font-bold text-white disabled:opacity-60">{busy && <Loader2 size={15} className="animate-spin" />} SAVE PASSWORD</button>
        </div>
    );
}
